import GPACalculatorPage from './GPACalculatorPage'

export default GPACalculatorPage;
